import { ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core';

import {
    ILinearBetslipMessagesProviderService,
    LINEAR_BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
} from '../../../../../../base/services/betslip-messages-provider.service';
import { BetslipType } from '../../../../../../core/betslip-type';
import { AlertType } from '../../../../../alerts/models';

@Component({
    selector: 'bs-linear-combo-prevention-notification',
    template: '<bs-alert [message]="nonCombinablePicks" [type]="type"></bs-alert>',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LinearComboPreventionNotificationComponent {
    @Input() betslipType: BetslipType;

    private readonly messages: {
        nonCombinableSystem: string;
        nonCombinableMulti: string;
        nonCombinableTeaser: string;
    };

    readonly type = AlertType.Warning;

    constructor(@Inject(LINEAR_BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) messageProvider: ILinearBetslipMessagesProviderService) {
        const combinedMessages = messageProvider.getMessages();

        this.messages = {
            nonCombinableSystem: combinedMessages.linear.NonCombinableSystem || combinedMessages.betslip.validation.ComboPrevention,
            nonCombinableMulti: combinedMessages.linear.NonCombinableMulti || combinedMessages.betslip.validation.ComboPrevention,
            nonCombinableTeaser: combinedMessages.linear.NonCombinableTeaser || combinedMessages.betslip.validation.ComboPrevention,
        };
    }

    get nonCombinablePicks(): string {
        switch (this.betslipType) {
            case BetslipType.System:
                return this.messages.nonCombinableSystem;

            case BetslipType.Teaser:
                return this.messages.nonCombinableTeaser;

            default:
                return this.messages.nonCombinableMulti;
        }
    }
}
